var _excluded = ["toBody", "contentRef", "getContainer", "wrapperRef", "wrapperClassName", "wrapperStyle", "mask", "maskClassName", "maskStyle", "onMaskClick", "style", "zIndex", "animation", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo, useRef } from 'react';
import { getZIndex, useCombineRef, useRefGetter } from '@okee-uikit/react-hooks';
import { useCSSEnterLeave } from '../../hooks/animation';
import { RcMask } from '../../hooks/mask';
import { RcPortal } from '../../hooks/portal';
import { LayerContext } from '../../context/layer';
import { useLayer } from '../../hooks/useLayer';

function RcDialogFC(props) {
  var _props$toBody = props.toBody,
      toBody = _props$toBody === void 0 ? false : _props$toBody,
      contentRef = props.contentRef,
      getContainer = props.getContainer,
      _props$wrapperRef = props.wrapperRef,
      wrapperRef = _props$wrapperRef === void 0 ? null : _props$wrapperRef,
      wrapperClassName = props.wrapperClassName,
      wrapperStyle = props.wrapperStyle,
      mask = props.mask,
      maskClassName = props.maskClassName,
      _props$maskStyle = props.maskStyle,
      maskStyle = _props$maskStyle === void 0 ? {} : _props$maskStyle,
      onMaskClick = props.onMaskClick,
      style = props.style,
      zIndex = props.zIndex,
      _props$animation = props.animation,
      animation = _props$animation === void 0 ? {
    disabled: true
  } : _props$animation,
      children = props.children,
      restProps = _objectWithoutProperties(props, _excluded);

  var getContainerGetter = useRefGetter(getContainer);
  var getLayer = useLayer(toBody);
  var wrapperRefObject = useRef(null);
  var innerWrapperRef = useCombineRef(wrapperRef, wrapperRefObject);
  var contentRefObject = useRef(null);
  var innerContentRef = useCombineRef(contentRef, contentRefObject);
  var wrapperZIndex = useMemo(function () {
    return zIndex !== null && zIndex !== void 0 ? zIndex : getZIndex();
  }, [zIndex]);
  var handleGetContainer = useCallback(function () {
    var getter = getContainerGetter();

    if (getter) {
      return getter();
    }

    return getLayer();
  }, []);
  useCSSEnterLeave(wrapperRefObject, animation);
  var onClickCallback = useCallback(function (e) {
    if (innerContentRef.current === e.target) {
      onMaskClick && onMaskClick(e);
    }
  }, [onMaskClick]);

  if (typeof window === 'undefined') {
    return null;
  }

  return React.createElement(RcPortal, {
    getContainer: handleGetContainer
  }, React.createElement("div", {
    ref: innerWrapperRef,
    className: wrapperClassName,
    style: _objectSpread({
      zIndex: wrapperZIndex
    }, wrapperStyle),
    onClick: onClickCallback
  }, mask && React.createElement(RcMask, {
    show: true,
    className: maskClassName,
    defaultStyle: false,
    style: maskStyle
  }), React.createElement(LayerContext.Provider, {
    value: innerContentRef
  }, React.createElement("div", _objectSpread(_objectSpread({}, restProps), {}, {
    ref: innerContentRef,
    style: _objectSpread({}, style),
    tabIndex: 0
  }), children))));
}

export var RcDialog = React.forwardRef(function (props, ref) {
  return React.createElement(RcDialogFC, _objectSpread(_objectSpread({}, props), {}, {
    wrapperRef: ref
  }));
});